import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import { M as MenuItem } from './MenuItem-ap5gxdWe.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import useAutoFocus from './hooks/useAutoFocus.js';
import './index-sNwiaBfD.js';
import 'next/router';
import 'notistack';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import Link from './components/Link/index.js';

const SubMenu = ({ item, onBack, setShowMobileMenu }) => {
    var _a;
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const ref = useAutoFocus();
    const { data: { locale }, } = useContext(CoreContext);
    const title = item.localized_menu_item_title || item.original_title;
    return (React.createElement("div", { className: "sub-menu-wrapper" },
        React.createElement("button", { ref: ref, type: "button", className: "button-back", "aria-label": tButton('back'), onClick: onBack },
            React.createElement("i", { className: "icon-left-arrow" }),
            title),
        React.createElement(Link, { href: `/${locale}${item.url}`, className: "button-see-all", onClick: () => setShowMobileMenu(false) }, tButton('seeAll')),
        React.createElement("ul", { className: "sub-menu" }, (_a = item.children) === null || _a === void 0 ? void 0 : _a.map((childItem, index) => (React.createElement(MenuItem
        // eslint-disable-next-line react/no-array-index-key
        , { 
            // eslint-disable-next-line react/no-array-index-key
            key: `${childItem.item_id}_${index}`, item: childItem, setShowMobileMenu: setShowMobileMenu }))))));
};

export { SubMenu as S };
//# sourceMappingURL=SubMenu-9iwuv3hI.js.map
